import Rest, { isApiErrorDetailInclude } from "../../src/core/rest";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getReduxActionErrorMessage, isReduxThunkPendingAction, isReduxThunkRejectedAction } from '../core/utils';

import { ApiGatewayUrl } from "../../src/appsettings";
import ErrorException from "src/components/ErrorException";
import { STATUS_TYPES } from '../core/constants';

const SLICE_NAME = "user";
export const getGroupFilterByAgency = createAsyncThunk(
  "user/getGroupFilterByAgency",
  async (id) => {
    try {
      const response = await Rest.get(ApiGatewayUrl + "/users/getGroupByAgency?agency_id=" + id);
      return response.data;
    } catch (ex) {
      ErrorException(ex.response);
    }
  }
)
export const roleLookUpData = createAsyncThunk(
  "user/roleLookUpData",
  async () => {
    try {
      const respond = await Rest.get(ApiGatewayUrl + "/users/roleLookUpData");
      return respond.data;
    } catch (ex) {
      ErrorException(ex.response);
    }

  }
)
export const getGroupSetForCSV = createAsyncThunk(
  "usergroups/getGroupSetForCSV",
  async () => {
    try {
      const respond = await Rest.get(ApiGatewayUrl + "/usergroups/getGroupsetforCSV");
      return respond.data;
    } catch (ex) {
      ErrorException(ex.response);
    }
  }
)
export const filterUsers = createAsyncThunk(
  "user/filterUsers",
  async (request) => {
    try {
      let user_role_ids = '';
      if (request.user_role_ids.length > 0) {
        user_role_ids = request.user_role_ids.join(",");
      }
      let gp_ids = '';
      if (request.user_grp_ids.length > 0) {
        gp_ids = request.user_grp_ids.join(",");
      }
      const getRequireData = Rest.get(ApiGatewayUrl + "/users/roleLookUpData");
      const getUsers = Rest.get(
        ApiGatewayUrl + "/users/search?page=" + request.page + "&rows_per_page=" + request.rows_per_page +
        "&agency_id=" + request.agency_id +
        "&user_role_ids=" + user_role_ids +
        "&user_grp_ids=" + gp_ids +
        "&keyword=" + request.filter_text
      );
      const response = await Rest.getAll([getRequireData, getUsers]);
      return JSON.stringify(response);
    } catch (ex) {
      ErrorException(ex.response);
    }

  }
)
export const getUserById = createAsyncThunk(
  "user/getUserById",
  async (request) => {
    try {
      let gpIds = '';
      let privacyList = '';
      let agencyIds = '';

      if (request.selectedCamGpIds.length > 0) { gpIds = request.selectedCamGpIds.join(','); }
      if (request.selectedPrivacyIds.length > 0) { privacyList = request.selectedPrivacyIds.join(','); }
      if (request.selected_agencyIds.length > 0) { agencyIds = request.selected_agencyIds.join(','); }

      const response = await Rest.get(
        ApiGatewayUrl + "/users?page=" + request.page + "&rows_per_page=" + request.rows_per_page
        + "&userId=" + request.user_id + "&agencyIds=" + agencyIds
        + "&search_val=" + request.search_val + "&selectedCamGpIds=" + gpIds
        + "&selectedPrivacyIds=" + privacyList
      );
      return response.data;
    }
    catch (ex) {
      ErrorException(ex.response);
    }
  }
)
export const createUsers = createAsyncThunk(
  "user/createUsers",
  async (userInfo, { rejectWithValue }) => {
    try {
      const response = await Rest.post(ApiGatewayUrl + "/users", userInfo.data);
      return response.data;
    }
    catch (ex) {
      if (isApiErrorDetailInclude(ex)) {
        return rejectWithValue(ex.response.data);
      }
      throw ex;
    }
  }
)

export const updateUser = createAsyncThunk(
  "user/updateUser",
  async (updateUserInfo) => {
    try {
      const response = await Rest.put(ApiGatewayUrl + "/users", updateUserInfo);
      return { response: response.data, updateUserInfo };
    }
    catch (ex) {
      ErrorException(ex.response);
    }

  }
)

export const disableUser = createAsyncThunk(
  "user/disableUser",
  async (userId) => {
    try {
      const respond = await Rest.put(ApiGatewayUrl + "/users/disable/" + userId)
      return respond.data;
    }
    catch (ex) {
      ErrorException(ex.response);
    }
  }
)

export const enableUser = createAsyncThunk(
  "user/enableUser",
  async (userId) => {
    try {
      const respond = await Rest.put(ApiGatewayUrl + "/users/enable/" + userId)
      return respond.data;
    }
    catch (ex) {
      ErrorException(ex.response);
    }
  }
)

export const deleteUsers = createAsyncThunk(
  "user/deleteUsers",
  async (id, { rejectWithValue }) => {
    try {
      const respond = await Rest.delete(ApiGatewayUrl + "/users/" + id)
      return respond.data;
    }
    catch (ex) {
      if (isApiErrorDetailInclude(ex)) {
        return rejectWithValue(ex.response.data);
      }
      throw ex.response;
    }
  }
)

export const userSlice = createSlice({
  name: "user",
  initialState: {
    users: [],
    roles: [],
    user: {},
    userById: {},
    superAdminList: [],
    user_groups: [],
    userGroupsbyAgency: [],
    selectedRoles: [],
    isLoading: false,
    userId: 0,
    errorMsg: "",
    total: 0,
    selectedAgencyId: 0,
    selectedGroupIds: [],
    selectedRoleIds: [],
    filterText: "",
    filterSuperAdmin: "",
    isCreated: false,
    changed: false,
    isEditing: false,
    cameraGpList: [],
    privacyList: [],
    cameras: [],
    camTotal: 0,
  },
  reducers: {
    updateSelectedAgencyId(state, action) {
      state.selectedAgencyId = action.payload;
    },
    selectedRoleIds(state, action) {
      state.selectedRoleIds = action.payload;
    },
    selectedGroupIds(state, action) {
      state.selectedGroupIds = action.payload;
    },
    filterText(state, action) {
      state.filterText = action.payload;
    },
    filterSuperAdmin(state, action) {
      state.filterSuperAdmin = action.payload;
    },
    updateUserGroupsbyAgency(state, action) {
      state.userGroupsbyAgency = action.payload;
    },
    saveChangedState: (state, action) => {
      state.changed = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGroupFilterByAgency.fulfilled, (state, action) => {
        return {
          ...state,
          user_groups: action.payload
        }
      })
      .addCase(roleLookUpData.fulfilled, (state, action) => {
        return {
          ...state,
          roles: action.payload.roles,
          selectedRoles: action.payload.selectedRoles
        }
      })
      .addCase(filterUsers.fulfilled, (state, action) => {
        const response = JSON.parse(action.payload);
        const requiredData = response[0].data;
        const users = response[1].data;
        return {
          ...state,
          users: users.users,
          roles: requiredData.roles,
          total: users.total,
          selectedRoles: requiredData.selectedRoles,
          userGroupsbyAgency: users.selectedGroups,
          user_groups: users.selectedGroups
        }
      })
      .addCase(getUserById.fulfilled, (state, action) => {
        return {
          ...state,
          userById: action.payload.user,
          cameraGpList: action.payload.camGpList,
          privacyList: action.payload.privacyList,
          cameras: action.payload.cameras,
          agencies: action.payload.agencies,
          camTotal: action.payload.total
        }
      })
      .addCase(createUsers.fulfilled, (state) => {
        return { ...state, isLoading: false }
      })
      .addCase(updateUser.pending, (state) => {
        return { ...state, isEditing: true };
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        let newList = [...state.users];
        let editedData = { ...action.payload.updateUserInfo }
        const findIdx = newList.findIndex(x => x.email === editedData.email);
        newList[findIdx] = { ...editedData };
        return { ...state, isEditing: false, users: newList }
      })
      .addCase(updateUser.rejected, (state, action) => {
        return { ...state, isEditing: false, errorMsg: action.error.message }
      })

      //handle pending actions.
      .addMatcher((action) => isReduxThunkPendingAction(SLICE_NAME, action.type), (state) => {
        return { ...state, isLoading: true, errorMessage: "" };
      })

      //handle rejected actions.   
      .addMatcher((action) => isReduxThunkRejectedAction(SLICE_NAME, action.type), (state, action) => {
        if (action.error && action.error.message === "Aborted") {
          return {
            ...state,
            isLoading: false,
            statusType: "",
            actionType: action.type?.split("/")[1],
            errorMessage: "",
          };
        } else {
          return {
            ...state,
            isLoading: false,
            actionType: action.type?.split("/")[1],
            statusType: STATUS_TYPES.rejected,
            errorMessage: getReduxActionErrorMessage(action)
          };
        }
      })
  }
});

export const userActions = userSlice.actions;
export const userState = (state) => state.user;
export default userSlice.reducer;